import React from 'react';
import { bool, func, string } from 'prop-types';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import useFormId from '../../hooks/useFormId';

import classes from './DataTypeSelect.module.css';

const Intervals = [
    {
        value: 5,
        label: '5'
    },
    {
        value: 10,
        label: '10'
    },
    {
        value: 15,
        label: '15'
    },
    {
        value: 30,
        label: '30'
    },
    {
        value: 60,
        label: '60'
    }
];
const NonCovDataTypes = ['', 'float'];

const SampleIntervalSelect = ({
    name,
    onChange,
    showLabel,
    type,
    value
}) => {
    const formId = useFormId(name);
    let label = null;
    let intervals = [...Intervals];

    if (showLabel) {
        label = (
            <InputLabel
                className={classes.label}
                htmlFor={formId}
            >
                Trend Interval
            </InputLabel>
        );
    }

    if (!NonCovDataTypes.includes(type)) {
        if (intervals[0].value !== 0) {
            intervals.unshift({
                value: 0,
                label: 'CoV'
            });
        }
    }

    return (
        <React.Fragment>
            {label}
            <Select
                id={formId}
                inputProps={{
                    classes: {
                        root: classes.input
                    }
                }}
                MenuProps={{
                    MenuListProps: {
                        className: classes.select
                    }
                }}
                name={name}
                onChange={onChange}
                value={value}
            >
                {intervals.map(({value, label}) => (
                    <MenuItem key={value} value={value}>{label}</MenuItem>
                ))}
            </Select>
        </React.Fragment>
    );
};

SampleIntervalSelect.defaultProps = {
    name:      'sampleInterval',
    onChange:  () => {},
    showLabel: true,
    type:      '',
    value:     ''
};

SampleIntervalSelect.propTypes = {
    name:      string,
    onChange:  func.isRequired,
    showLabel: bool
};

export default SampleIntervalSelect;
